<template>
    <footer v-if="this.$route.path == '/'" class="footer simpleFooter">
        <p>Ⓒ Copyright {{ year }} Hyundai Portugal.</p>
    </footer>
    <footer v-else :class="{footer: true, active: isOpen && isMobile, hide: isResumePage, 'close': isComparePage}">
        <div class="footer-wrap">
            <div class="footerSlider" @click="handleSlide">
                <span />
            </div>
            <div v-if="path != 'Resume'" class="footer-content">
                <div class="expandContent">
                    <svg @click="handleSlide" v-if="!isOpen" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L11.2929 7.29289Z" fill="#1C1B1B"/>
                    </svg>
                    <svg @click="handleSlide" v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#1C1B1B"/>
                    </svg>
                </div>

                <div class="footer-content--price">
                    <p>Preço desde</p>
                    <p class="h4">{{ getPrice | format_thousands }} €
                        <svg @click="openModal(isCredit ? true : false)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg>
                    </p>
                </div>

                <div class="footer-content--info">
                    <p>Mensalidade: <span>{{ parseFloat(resumeData.rent) | format_thousands(true)}} €</span></p>
                    <p>TAEG: <span>{{ parseFloat(resumeData.taeg).toFixed(1) | format_thousands(true, 1)}} %</span></p>

                </div>

                <div v-show="isOpen || !isMobile" class="footer-content--extra">
                    <p>Entrada inicial: <span>{{ parseFloat(resumeData.incialEntry) | format_thousands(true)}} €</span></p>
                    <p v-show="resumeData.maxMounths">Prazo: <span>{{ parseFloat(resumeData.maxMounths).toFixed(1) | format_thousands}} meses</span></p>
                    <p>Montante financiado: <span>{{ parseFloat(resumeData.financing).toFixed(2) | format_thousands}} €</span></p>
                    <p v-show="!this.isCredit">Última Mensalidade: <span>{{ parseFloat(resumeData.hasFinances.residualValue).toFixed(2) | format_thousands}} €</span></p>
                </div>
            </div>

            <router-link v-show="prevRoute != ''" class="btn-footer-prev" :to="prevRoute">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.7071 18.7071C16.0976 18.3166 16.0976 17.6834 15.7071 17.2929L10.4142 12L15.7071 6.70711C16.0976 6.31658 16.0976 5.68342 15.7071 5.29289C15.3166 4.90237 14.6834 4.90237 14.2929 5.29289L8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L14.2929 18.7071C14.6834 19.0976 15.3166 19.0976 15.7071 18.7071Z" fill="currentColor"/>
                </svg>
                {{ prevText }}
            </router-link>

            <router-link
            v-if="path != 'Resume'"
            :class="{'btn-primary-rightIcon': true, full: path == 'Motors'}"
            role="button"
            :to="nextRoute"
            @click.native="handleDataLayer()">
                {{ nextText }}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z" fill="currentColor"/>
                </svg>
            </router-link>
            <button v-else class="btn-primary-rightIcon" @click="openFormPropose">Pedir Proposta</button>
        </div>
    </footer>
</template>
<script>
    import { mapGetters, mapMutations, mapState } from 'vuex';
    import { windowResized } from '@/mixins/windowEventListeners'
    import { modalPrice } from '../../mixins/modalFunctions'
    import { handleDataLayer } from '../../mixins/handleDataLayer'
import { modalForms } from '../../mixins/modalForms';

    export default {
        name: 'Footer',
        mixins: [windowResized, modalPrice, handleDataLayer, modalForms],
        props: {
            prevRoute: { type: String, default: ''},
            nextRoute: { type: String, default: ''},
        },
        data(){return{
            year: new Date().getFullYear(),
            isOpen: false,
            // footerHeight: 0,
            isComparePage: false,
            isResumePage: false,
            prevText: 'Anterior',
            nextText: 'Continuar',
            gama: 'Nova Configuração',
            path: null,
            modalParam: 2,
        }},
        mounted(){
            this.setProperties(true);
        },
        updated(){
            this.setProperties();
            this.isComparePage = (this.$route.name == 'Comparator') ? true : false;
            this.isResumePage = (this.$route.name == 'Resume') ? true : false;
            this.path = this.$route.name
        },
        watch: {
            isMobile: function(val, prev){
                if(prev == false && val) this.isOpen = false;
            },
            $route: function(){
                this.isOpen = false
            },
        },
        computed: {
            ...mapState(['resumeData']),
            ...mapGetters({
                modelPrice: 'resumeData/getFullPrice'
            }),
            handleInfoSectionContent(){
                let rD = this.resumeData;
                return `${rD.maxMounths}  meses. Entrada inicial: ${rD.incialEntry} €. Financiamento: ${rD.financing} €`;
            },
            isCredit(){
                return this.resumeData.creditType == 'CREDIT'
            },
            getPrice(){
                const val = this.isCredit ? this.resumeData.basePrice : this.resumeData.hasFinances.pvp
                return parseFloat(val).toFixed(2)
            }
        },
        methods:{
            ...mapMutations({
                updateRootState:'UPDATE_ROOT_STATE',
            }),
            handleSlide(){
                this.isOpen = !this.isOpen;
                document.body.classList.toggle('isActive')
            },
            setProperties(updateFooterMargin=false){
                let footer = document.querySelector('.footer');
                if(footer){
                    let height = footer.offsetHeight
                    this.footerHeight = height;
                    (this.isOpen || updateFooterMargin) && this.updateRootState({ footerHeight: height })
                }
            },
            openModal(hodOrCredit=false){
                this.$store.commit('modalData/UPDATE_MODALSTATE', {
                    openModal: true,
                    component: 'DefaultModalContent',
                    title: this.setModalTitle(this.handleModalFinTitle, false),
                    content: this.setFinanceContent(hodOrCredit, this.handleModalFinData),
                });
                document.body.classList.add('isActive')
            },
            handleDataLayer(){
                const routeProps = this.$route.matched[1].props.default
                const step = routeProps.id - 1
                this.setDataLayerStepSelection(step)
            }
        },
    }
</script>
<style lang="scss">
    @import './Footer.scss';
</style>
